export const SESSION_ID_COOKIE_NAME = "session_id";
export const enum SOCIAL_MEDIA {
    FACEBOOK = "facebook",
    TWITTER = "twitter",
    APPLE = "apple",
    LINKED_IN = "linked-in",
    TERMINAL = "terminal"
}
export const STUDENT_OFFER = "STUDENT";
export const SUBSCRIPTION_FORM_VALIDATE_SHIPPING = "SUBSCRIPTION_FORM_VALIDATE_SHIPPING";
export const SUBSCRIPTION_FORM_VALIDATE_PERIOD_ERROR = "SUBSCRIPTION_FORM_VALIDATE_PERIOD_ERROR";
export const SUBSCRIPTION_FORM_VALIDATE_NORTH_DAKOTA_USER = "SUBSCRIPTION_FORM_VALIDATE_NORTH_DAKOTA_USER";
export const USER_ID_COOKIE_NAME = "_user-id";
export const enum SUBSCRIPTION_TYPE {
    DIGITAL = "DIGITAL",
    ALL = "ALL",
    BULK = "BULK"
}

export const THINKING_TYPE_LOADING = "loading";
export const THINKING_TYPE_PROCESSING = "processing";
export const ASCII_ONLY_PATTERN = "[\x20-\x7F]+";
export const SUBSCRIPTION_ADDRESS_VALIDATION_TEXT = "Shipping address can only contain English language characters.";
export const SUBSCRIPTION_ADDRESS_VALIDATION_NORTH_DAKOTA_USER = "We are unable to complete your purchase. Please try selecting a monthly offer, an annual offer, or contacting <a href=\"http://www.bloomberg.com/feedback\">Customer Support.</a>";
export const PREVIEW_COOKIE_NAME = "tagalong";
export const PREVIEW_COOKIE_VALUE = "milk";
export const NEWSLETTER_UPDATE_SOURCE_LOGGED_IN = "account_settings";
export const NEWSLETTER_UPDATE_SOURCE_LOGGED_OUT = "landing_page";
export const NEWSLETTER_UPDATE_SOURCE_STANDALONE_PAGE = "standalone_page";
export const NEWSLETTER_SUBSCRIBE_SOURCE_LOGGED_IN = "tout_logged_in";
export const NEWSLETTER_SUBSCRIBE_SOURCE_LOGGED_OUT = "tout_logged_out";
export const BULK_SUBSCRIPTION_MAX_ADMIN_USERS = 2;
export enum BULK_SUBSCRIPTION_USER_ROLES {
    ADMIN = "ADMIN",
    USER = "USER"
}
